import { Injectable } from "@angular/core";
import { CanLoad, Router } from "@angular/router";
import { Storage } from "@ionic/storage";
@Injectable({
  providedIn: "root",
})
export class CheckTutorial implements CanLoad {
  constructor(private storage: Storage, private router: Router) {
    this.storage.get("ion_did_tutorial").then((res) => { //check if the user has completed the tutorial
                                                         //by checking the storage 
      if (res == true) {
        this.router.navigate(["/home"]);  //redirect user to home if tutorial has been completed
        return false;
      } else {
        return true;
      }
    });
  }

  //run this function on call
  canLoad() {
    return this.storage.get("ion_did_tutorial").then((res) => {
      if (res == true) {
        this.router.navigate(["/home"]);
        return false;
      } else {
        return true;
      }
    });
  }
}
